<template>
    <section class="section all-races">
        <h2
            :style="{textShadow: '0px 0px 7px rgb(0,0,0)'}"
            class="title is-size-3 has-text-centered is-uppercase has-text-white"
        >
            Formula 1 2026 Season - Session Times
        </h2>
        <!-- <div class="columns has-background-secondary">
            <div class="column has-text-centered is-uppercase has-text-white is-size-6">
                <a class="button is-size-7" :href="'/calendar/' + parseInt(new Date().getFullYear() - 1)">
                    Previous Season
                </a>
            </div>
            <div class="column has-text-centered is-uppercase has-text-white is-size-6">
                <a class="button is-size-7" href="/seasons">
                    All Seasons
                </a>
            </div>
            <div class="column has-text-centered is-uppercase has-text-white is-size-6">
                <a class="button is-size-7" :href="'/standings/' + parseInt(new Date().getFullYear())">
                    Standings
                </a>
            </div>
        </div> -->
        <div class="columns is-multiline is-mobile is-centered">
            <div
                v-for="(race, index) in raceList.dates"
                :key="index"
                class="column is-paddingless is-one-fifth is-race-info is-one-third-tablet is-clipped"
            >
                <div class="race-info-content">
                    <div
                        class="race-flag-bg"
                        :class="{ 'is-generic': race.is_generic }"
                        :style="{ background: 'linear-gradient(rgba(0, 0, 0, 0.5), rgba(25, 25, 25, 0.6)), url(/img/FlagKit/' + encodeURI(race.flag_name) + '.svg) no-repeat'}"
                    />
                    <div
                        v-if="(race.is_cancelled == 1)"
                        class="text-container is-centered as-text-white has-text-shadow is-size-4-mobile has-text-centered has-smaller-text-mobile"
                        style="justify-content: flex-start;"
                    >
                        <p class="has-text-white has-text-shadow is-size-4-mobile has-text-centered has-smaller-text-mobile has-text-weight-bold">
                            <a
                                class="has-text-white"
                            >
                                {{ race.race_title }}
                            </a>
                        </p>
                        <p v-html="race.cancelled_text" />
                    </div>
                    <div
                        v-else
                        class="text-container is-centered has-text-white has-text-shadow is-size-4-mobile has-text-centered has-smaller-text-mobile"
                    >
                        <p class="has-text-weight-bold">
                            <a
                                class="has-text-white"
                                :href="'results/2026/' + (race.id + 1)"
                            >
                                {{ race.race_title }}
                            </a>
                        </p>
                        <p v-if="race.fp1_timestamp !== '0000-00-00 00:00:00'">
                            <strong class="has-text-white">FP1: </strong>{{ race.fp1_timestamp | moment("DD/MM/YYYY HH:mm:SS") }}
                        </p>
                        <p v-if="race.fp1_timestamp !== '0000-00-00 00:00:00'">
                            <strong class="has-text-white">FP2: </strong>{{ race.fp2_timestamp | moment("DD/MM/YYYY HH:mm:SS") }}
                        </p>
                        <p><strong class="has-text-white">FP3: </strong>{{ race.fp3_timestamp | moment("DD/MM/YYYY HH:mm:SS") }}</p>
                        <p><strong class="has-text-white">Qual: </strong>{{ race.qual_timestamp | moment("DD/MM/YYYY HH:mm:SS") }}</p>
                        <p><strong class="has-text-white">Race: </strong>{{ race.race_timestamp | moment("DD/MM/YYYY HH:mm:SS") }}</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data () {
        return {
            raceList: {
                dates: [
                    {
                        id: 1,
                        race_title: 'Australian Grand Prix',
                        fp1_timestamp: '2026-03-06 01:30:00',
                        fp2_timestamp: '2026-03-06 05:00:00',
                        fp3_timestamp: '2026-03-07 01:30:00',
                        qual_timestamp: '2026-03-07 05:00:00',
                        race_timestamp: '2026-03-08 04:00:00',
                        country_code: 'AUS',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Australia'
                    },
                    {
                        id: 2,
                        race_title: 'Chinese Grand Prix',
                        fp1_timestamp: '2026-03-13 03:30:00',
                        fp2_timestamp: '2026-03-13 07:30:00',
                        fp3_timestamp: '2026-03-14 03:00:00',
                        qual_timestamp: '2026-03-14 07:00:00',
                        race_timestamp: '2026-03-15 07:00:00',
                        country_code: 'CHN',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'China'
                    },
                    {
                        id: 3,
                        race_title: 'Japanese Grand Prix',
                        fp1_timestamp: '2026-03-27 02:30:00',
                        fp2_timestamp: '2026-03-27 06:00:00',
                        fp3_timestamp: '2026-03-28 02:30:00',
                        qual_timestamp: '2026-03-28 06:00:00',
                        race_timestamp: '2026-03-29 05:00:00',
                        country_code: 'JPN',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Japan'
                    },
                    {
                        id: 4,
                        race_title: 'Bahrain Grand Prix',
                        fp1_timestamp: '2026-04-10 11:30:00',
                        fp2_timestamp: '2026-04-10 15:00:00',
                        fp3_timestamp: '2026-04-11 12:30:00',
                        qual_timestamp: '2026-04-11 16:00:00',
                        race_timestamp: '2026-04-12 15:00:00',
                        country_code: 'BAH',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Bahrain'
                    },
                    {
                        id: 5,
                        race_title: 'Saudi Arabian Grand Prix',
                        fp1_timestamp: '2026-04-17 13:30:00',
                        fp2_timestamp: '2026-04-17 17:00:00',
                        fp3_timestamp: '2026-04-18 13:30:00',
                        qual_timestamp: '2026-04-18 17:00:00',
                        race_timestamp: '2026-04-19 17:00:00',
                        country_code: 'SAU',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Saudi Arabia'
                    },
                    {
                        id: 6,
                        race_title: 'Miami Grand Prix',
                        fp1_timestamp: '2026-05-01 16:30:00',
                        fp2_timestamp: '2026-05-01 20:30:00',
                        fp3_timestamp: '2026-05-02 16:00:00',
                        qual_timestamp: '2026-05-02 20:00:00',
                        race_timestamp: '2026-05-03 20:00:00',
                        country_code: 'USA',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'United States'
                    },
                    {
                        id: 7,
                        race_title: 'Canadian Grand Prix',
                        fp1_timestamp: '2026-05-22 16:00:00',
                        fp2_timestamp: '2026-05-22 20:00:00',
                        fp3_timestamp: '2026-05-23 16:00:00',
                        qual_timestamp: '2026-05-23 20:00:00',
                        race_timestamp: '2026-05-24 20:00:00',
                        country_code: 'CAN',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Canada'
                    },
                    {
                        id: 8,
                        race_title: 'Monaco Grand Prix',
                        fp1_timestamp: '2026-06-05 09:30:00',
                        fp2_timestamp: '2026-06-05 13:00:00',
                        fp3_timestamp: '2026-06-06 08:30:00',
                        qual_timestamp: '2026-06-06 12:00:00',
                        race_timestamp: '2026-06-07 13:00:00',
                        country_code: 'MCO',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Monaco'
                    },
                    {
                        id: 9,
                        race_title: 'Barcelona Grand Prix',
                        fp1_timestamp: '2026-06-12 09:30:00',
                        fp2_timestamp: '2026-06-12 13:00:00',
                        fp3_timestamp: '2026-06-13 08:30:00',
                        qual_timestamp: '2026-06-13 12:00:00',
                        race_timestamp: '2026-06-14 13:00:00',
                        country_code: 'ESP',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Spain'
                    },
                    {
                        id: 10,
                        race_title: 'Austrian Grand Prix',
                        fp1_timestamp: '2026-06-26 09:30:00',
                        fp2_timestamp: '2026-06-26 13:00:00',
                        fp3_timestamp: '2026-06-27 08:30:00',
                        qual_timestamp: '2026-06-27 12:00:00',
                        race_timestamp: '2026-06-28 13:00:00',
                        country_code: 'AUT',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Austria'
                    },
                    {
                        id: 11,
                        race_title: 'British Grand Prix',
                        fp1_timestamp: '2026-07-03 11:00:00',
                        fp2_timestamp: '2026-07-03 15:00:00',
                        fp3_timestamp: '2026-07-04 10:00:00',
                        qual_timestamp: '2026-07-04 15:00:00',
                        race_timestamp: '2026-07-05 14:00:00',
                        country_code: 'GBR',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'United Kingdom'
                    },
                    {
                        id: 12,
                        race_title: 'Belgian Grand Prix',
                        fp1_timestamp: '2026-07-17 09:30:00',
                        fp2_timestamp: '2026-07-17 13:00:00',
                        fp3_timestamp: '2026-07-18 08:30:00',
                        qual_timestamp: '2026-07-18 12:00:00',
                        race_timestamp: '2026-07-19 13:00:00',
                        country_code: 'BEL',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Belgium'
                    },
                    {
                        id: 13,
                        race_title: 'Hungarian Grand Prix',
                        fp1_timestamp: '2026-07-24 09:30:00',
                        fp2_timestamp: '2026-07-24 13:00:00',
                        fp3_timestamp: '2026-07-25 08:30:00',
                        qual_timestamp: '2026-07-25 12:00:00',
                        race_timestamp: '2026-07-26 13:00:00',
                        country_code: 'HUN',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Hungary'
                    },
                    {
                        id: 14,
                        race_title: 'Dutch Grand Prix',
                        fp1_timestamp: '2026-08-21 08:30:00',
                        fp2_timestamp: '2026-08-21 12:00:00',
                        fp3_timestamp: '2026-08-22 08:00:00',
                        qual_timestamp: '2026-08-22 12:00:00',
                        race_timestamp: '2026-08-23 13:00:00',
                        country_code: 'NLD',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Netherlands'
                    },
                    {
                        id: 15,
                        race_title: 'Italian Grand Prix',
                        fp1_timestamp: '2026-09-04 08:30:00',
                        fp2_timestamp: '2026-09-04 12:00:00',
                        fp3_timestamp: '2026-09-05 08:30:00',
                        qual_timestamp: '2026-09-05 12:00:00',
                        race_timestamp: '2026-09-06 13:00:00',
                        country_code: 'ITA',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Italy'
                    },
                    {
                        id: 16,
                        race_title: 'Spanish Grand Prix',
                        fp1_timestamp: '2026-09-11 09:30:00',
                        fp2_timestamp: '2026-09-11 13:00:00',
                        fp3_timestamp: '2026-09-12 08:30:00',
                        qual_timestamp: '2026-09-12 12:00:00',
                        race_timestamp: '2026-09-13 13:00:00',
                        country_code: 'ESP',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Spain'
                    },
                    {
                        id: 17,
                        race_title: 'Azerbaijan Grand Prix',
                        fp1_timestamp: '2026-09-25 07:30:00',
                        fp2_timestamp: '2026-09-25 11:00:00',
                        fp3_timestamp: '2026-09-26 07:30:00',
                        qual_timestamp: '2026-09-26 11:00:00',
                        race_timestamp: '2026-09-27 11:00:00',
                        country_code: 'AZE',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Azerbaijan'
                    },
                    {
                        id: 18,
                        race_title: 'Singapore Grand Prix',
                        fp1_timestamp: '2026-10-09 04:00:00',
                        fp2_timestamp: '2026-10-09 09:00:00',
                        fp3_timestamp: '2026-10-10 09:00:00',
                        qual_timestamp: '2026-10-10 13:00:00',
                        race_timestamp: '2026-10-11 12:00:00',
                        country_code: 'SGP',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Singapore'
                    },
                    {
                        id: 19,
                        race_title: 'United States Grand Prix (Austin)',
                        fp1_timestamp: '2026-10-23 17:00:00',
                        fp2_timestamp: '2026-10-23 21:00:00',
                        fp3_timestamp: '2026-10-24 16:30:00',
                        qual_timestamp: '2026-10-24 21:00:00',
                        race_timestamp: '2026-10-25 20:00:00',
                        country_code: 'USA',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'United States'
                    },
                    {
                        id: 20,
                        race_title: 'Mexico Grand Prix',
                        fp1_timestamp: '2026-10-31 00:30:00',
                        fp2_timestamp: '2026-10-31 04:00:00',
                        fp3_timestamp: '2026-10-31 23:30:00',
                        qual_timestamp: '2026-11-01 03:00:00',
                        race_timestamp: '2026-11-02 02:00:00',
                        country_code: 'MEX',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Mexico'
                    },
                    {
                        id: 21,
                        race_title: 'Brazilian Grand Prix',
                        fp1_timestamp: '2026-11-06 18:30:00',
                        fp2_timestamp: '2026-11-06 22:00:00',
                        fp3_timestamp: '2026-11-07 17:30:00',
                        qual_timestamp: '2026-11-07 21:00:00',
                        race_timestamp: '2026-11-08 20:00:00',
                        country_code: 'BRA',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Brazil'
                    },
                    {
                        id: 22,
                        race_title: 'Las Vegas Grand Prix',
                        fp1_timestamp: '2026-11-20 08:30:00',
                        fp2_timestamp: '2026-11-20 12:00:00',
                        fp3_timestamp: '2026-11-21 08:30:00',
                        qual_timestamp: '2026-11-21 12:00:00',
                        race_timestamp: '2026-11-22 12:00:00',
                        country_code: 'USA',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'United States'
                    },
                    {
                        id: 23,
                        race_title: 'Qatar Grand Prix',
                        fp1_timestamp: '2026-11-27 10:30:00',
                        fp2_timestamp: '2026-11-27 14:00:00',
                        fp3_timestamp: '2026-11-28 11:30:00',
                        qual_timestamp: '2026-11-28 15:00:00',
                        race_timestamp: '2026-11-29 16:00:00',
                        country_code: 'QAT',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'Qatar'
                    },
                    {
                        id: 24,
                        race_title: 'Abu Dhabi Grand Prix',
                        fp1_timestamp: '2026-12-04 05:30:00',
                        fp2_timestamp: '2026-12-04 09:00:00',
                        fp3_timestamp: '2026-12-05 06:30:00',
                        qual_timestamp: '2026-12-05 14:00:00',
                        race_timestamp: '2026-12-06 13:00:00',
                        country_code: 'ARE',
                        active: 0,
                        is_cancelled: 0,
                        cancelled_text: '',
                        flag_name: 'United Arab Emirates'
                    }
                ]
            }
        }
    }
}
</script>
